import { render, staticRenderFns } from "./AbastecimentoAdmSinteticoRead.vue?vue&type=template&id=7f83eae4&"
import script from "./AbastecimentoAdmSinteticoRead.vue?vue&type=script&lang=js&"
export * from "./AbastecimentoAdmSinteticoRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports